import * as React from 'react';
import './card.css';

/**
 * Card (CC10): one surface. White, 28px radius, gray-200 hairline, one static
 * layered shadow. `nested` drops to the 20px tile radius for cards inside
 * cards; `hover` adds the opacity-only glow lift used on the landing.
 * Padding defaults to 20px and can still be overridden through `style`.
 */
export function Card({
  children,
  className = '',
  style,
  nested = false,
  hover = false,
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  nested?: boolean;
  hover?: boolean;
}) {
  const classes = [
    'lnr-card',
    nested ? 'lnr-card--nested' : '',
    hover ? 'lnr-card--hover' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <div className={classes} style={style}>
      {children}
    </div>
  );
}
